import { z } from "zod";
/**
 * Vaccine type is "a configuration lookup value, not a fixed enum — new
 * types are addable as data" (`docs/products/stable.md` "Vaccinations").
 * This is why it is a validated code string rather than a Zod `z.enum` (which
 * would require a code change/migration to add a type) and why the database
 * models it as rows in `stable_vaccine_types`, not a Postgres CHECK-enum
 * column (`packages/database/AGENTS.md`: "Use PostgreSQL enums only for
 * genuinely stable closed sets" — vaccine types are explicitly not one).
 */
export const VaccineTypeCodeSchema = z
    .string()
    .regex(/^[A-Z][A-Z0-9_]{1,49}$/, "vaccineType must be an uppercase code, e.g. EQUINE_INFLUENZA.");
export const VaccineTypeConfigSchema = z
    .object({
    code: VaccineTypeCodeSchema,
    label: z.string().trim().min(1).max(120),
    intervalDays: z.number().int().min(1).max(3650).nullable(),
    alertingEnabled: z.boolean(),
})
    .strict();
export function isKnownVaccineType(registry, code) {
    return Object.hasOwn(registry, code);
}
